import { mapGetters } from "vuex";
import MesssagesCounter from "../../../components/MessagesCounter";

import LoadingIcon from "@/assets/images/icons/loading-white.svg?inline";

export default {
  name: "agent_profile",

  data() {
    return {};
  },

  props: [],

  mounted: function() {},

  computed: {
    ...mapGetters({
      currentUser: "getUser"
    }),

    loadingProfile() {
      if (localStorage.getItem("AUTH_TOKEN")) {
        return true;
      } else {
        this.$router.push({ name: "home" });
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("AUTH_TOKEN")) {
      next();
    } else {
      next({ name: "home" });
    }
  },

  methods: {},

  components: {
    LoadingIcon,
    MesssagesCounter
  }
};
